export default "__VITE_ASSET__B07C2xSz__"